export default __webpack_public_path__ + "static/media/illi3.6e804810.png";